module.exports = __webpack_public_path__ + "static/media/1.e2945a48.png";